namespace GeniuzPOS.Inventory {
    export namespace IcStockReturnOutDtService {
        export const baseUrl = 'Inventory/IcStockReturnOutDt';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<IcStockReturnOutDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<IcStockReturnOutDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Inventory/IcStockReturnOutDt/Retrieve",
            List = "Inventory/IcStockReturnOutDt/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>IcStockReturnOutDtService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
